import React, { useContext } from "react"

import { withOrientationChange } from "react-device-detect"

import Grid from "../grid/grid.component"

import {
  CompaniesTitle,
  CompaniesTitleContainer,
  CompanyBarImages,
  CompanyImage,
  CompanyLogoBarContainer,
  MarqueeContainer
} from "./company-logo-bar.styles"
import Marquee from "react-fast-marquee"

import MobileContext from "../../providers/mobile/mobile.provider"

const CompaniesBar = ({
  title,
  images,
  titleColor,
  backgroundColor,
  isLandscape,
  mobileSpeed = 75,
  desktopSpeed = 100,
  isNewsletterPage,
  hasBackground = true
}) => {
  const { isMobile } = useContext(MobileContext)

  const imageArray = []
  // If < 20 images duplicate them to prevent the gap at the end/start of marquee
  if (images.length < 20) {
    while (imageArray.length < 20) {
      images.map((i) => imageArray.push(i))
    }
  } else images.map((i) => imageArray.push(i))
  const hexToRgb = (hex) => {
    const bigint = parseInt(hex.replace("#", ""), 16)
    const r = (bigint >> 16) & 255
    const g = (bigint >> 8) & 255
    const b = bigint & 255

    return r + "," + g + "," + b
  }

  const rgbBgColor = hexToRgb(backgroundColor)

  return (
    <CompanyLogoBarContainer className="full-bleed" hasBackground={hasBackground} bgColor={rgbBgColor} isNewsletterPage={isNewsletterPage}>
      <CompaniesTitleContainer>
        <Grid>
          <CompaniesTitle hasBackground={hasBackground} titleColor={titleColor}>{title}</CompaniesTitle>
        </Grid>
      </CompaniesTitleContainer>
      <MarqueeContainer bgColor={rgbBgColor} hasBackground={hasBackground}>
        <CompanyBarImages isLandscape={isLandscape} isNewsletterPage={isNewsletterPage}>
          <Marquee speed={isMobile ? mobileSpeed : desktopSpeed}>
            {imageArray.map(({ title, file, id }) => (
              <CompanyImage
                src={`${file.url}?w=160`}
                alt={title}
                width={160}
                height={60}
              />
            ))}
          </Marquee>
        </CompanyBarImages>
      </MarqueeContainer>
    </CompanyLogoBarContainer>
  )
}

export default withOrientationChange(CompaniesBar)
